import React, { useState, useRef, useEffect } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import rfdc from 'rfdc';
import { ResetZoomButton } from './ResetZoomButton';
import { getDefaultMasterChartOptions, setUpdatedDetailsOptions, getCustomOptions, plotOptionsSet, } from '../utils';
const clone = rfdc();
export const DetailedTimeseriesChart = ({ detailChartData, isSearchTreeCollapsed = false, isSideBarCollapsed = false, }) => {
    const clonedApiData = clone(detailChartData);
    const [showReset, setShowReset] = useState(false);
    const [detailChartDataUpdated, setDetailChartData] = useState(detailChartData);
    const [currentFactorTimeseriesData] = useState(clonedApiData);
    const detailsChartRef = useRef(null);
    const masterChartRef = useRef(null);
    const [detailChartOptions] = useState(getCustomOptions());
    const [masterChartOptions] = useState(getDefaultMasterChartOptions({
        apiData: currentFactorTimeseriesData,
        setDetailChartData,
        setShowReset,
    }));
    useEffect(() => {
        var _a, _b;
        (_a = masterChartRef.current) === null || _a === void 0 ? void 0 : _a.chart.reflow();
        (_b = detailsChartRef.current) === null || _b === void 0 ? void 0 : _b.chart.reflow();
    }, [isSearchTreeCollapsed, isSideBarCollapsed]);
    const restrictedWidthStyle = {
        width: `calc(100vw ${!isSearchTreeCollapsed ? '- 280px' : ''} ${!isSideBarCollapsed ? '- 200px' : '- 60px'})`,
    };
    return (React.createElement("div", { className: "details-chart", style: restrictedWidthStyle },
        showReset && (React.createElement(ResetZoomButton, { currentFactorTimeseriesData: currentFactorTimeseriesData, masterChartRef: masterChartRef, setDetailChartData: setDetailChartData, setShowReset: setShowReset, showReset: showReset })),
        React.createElement(HighchartsReact, { ref: detailsChartRef, highcharts: Highcharts, options: Object.assign(Object.assign({}, detailChartOptions), { series: detailChartDataUpdated.map((data) => (Object.assign({ type: 'line', marker: {
                        enabled: false,
                    } }, data))) }) }),
        React.createElement(HighchartsReact, { highcharts: Highcharts, ref: masterChartRef, options: Object.assign(Object.assign({}, setUpdatedDetailsOptions(masterChartOptions, currentFactorTimeseriesData)), plotOptionsSet({ detailsChartRef })), updateArgs: [true, true] })));
};
//# sourceMappingURL=DetailedTimeseriesChart.js.map